import { render, staticRenderFns } from "./MortgageBlock.vue?vue&type=template&id=66963710&scoped=true&"
import script from "./MortgageBlock.vue?vue&type=script&lang=js&"
export * from "./MortgageBlock.vue?vue&type=script&lang=js&"
import style0 from "./MortgageBlock.vue?vue&type=style&index=0&id=66963710&lang=scss&"
import style1 from "./MortgageBlock.vue?vue&type=style&index=1&id=66963710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66963710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66963710')) {
      api.createRecord('66963710', component.options)
    } else {
      api.reload('66963710', component.options)
    }
    module.hot.accept("./MortgageBlock.vue?vue&type=template&id=66963710&scoped=true&", function () {
      api.rerender('66963710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/MortgageBlock.vue"
export default component.exports